<template>
  <div class="lecture_content_block clearfix">
    <div class="date_area">
      <div class="year">
        {{ lecture.lecture_start_date | moment("YYYY") }}/
      </div>
      <div class="date">
        {{ lecture.lecture_start_date | moment("MM/DD") }}
      </div>
    </div>
    <div class="content_area clearfix">
      <div class="content_title">
        {{ lecture.lecture_subject }}
      </div>
      <div class="info">
        <div class="time clearfix">
          <div class="title">
            時間
          </div>
          <div class="text">
            {{ lecture.lecture_start_date || new Date() | moment("HH:mm") }}~{{ lecture.lecture_end_date || new Date() | moment("HH:mm") }}
          </div>
        </div>
        <div class="location clearfix">
          <div class="title">
            地點
          </div>
          <div class="text">
            {{ lecture.lecture_location }}
          </div>
        </div>
      </div>
      <div class="presenter clearfix">
        <div class="title clearfix">
          主講人
        </div>
        <div class="text clearfix">
          {{ lecture.lecture_name }}
        </div>
      </div>
      <div v-if="lecture.lecture_show_status" class="registration_status">
        <div class="title">
          活動狀態
        </div>
        <div class="text" :class="{full: lecture.lecture_students_count >= lecture.lecture_taker}">
          <span>{{ lecture.lecture_students_count }}/{{ lecture.lecture_taker }}</span>(已報名/總名額)
        </div>
      </div>
      <div class="detail_block">
        <router-link
		  :to="`/lectures/${lectureType}/${lecture.lecture_id}`"
          class="detail_bt"
        >
          活動詳情
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LecturesIndexCard',
  props: {
    lecture: {
      type: Object,
      default: () => {}
    },
    lectureType: {
      type: String,
      default: ''
    }
  }
}
</script>
